import {
  ContratoStatus,
  ContratoTipoNotificacao,
  TipoContrato,
  TipoFluxo,
} from 'models/contratos';

export const mapTipoText = (tipo) => {
  switch (tipo) {
    case ContratoTipoNotificacao.ANALISE_OPERACIONAL_CONCLUIDA:
      return 'Análise operacional concluída';
    case ContratoTipoNotificacao.ALTERACAO_DE_SITUACAO:
      return 'Alteração de situação';
    default:
      return `Tipo desconhecido (${tipo})`;
  }
};

export const mapStatusToText = (status) => {
  const statusMapping = {
    [ContratoStatus.EM_EDICAO]: 'Em edição',
    [ContratoStatus.EM_ANALISE_OPERACIONAL]: 'Em análise',
    [ContratoStatus.AGUARDANDO_ASSINATURA]: 'Aguardando assinatura',
    [ContratoStatus.NAO_INICIADO]: 'Não iniciado',
    [ContratoStatus.VIGENTE]: 'Vigente',
    [ContratoStatus.ENCERRADO]: 'Encerrado',
    [ContratoStatus.DESATIVADO]: 'Desativado',
    [ContratoStatus.ASSINADO]: 'Assinado',
    [ContratoStatus.AGUARDANDO_EXTRATO]: 'Aguardando extrato',
    [ContratoStatus.ANALISE_OPERACIONAL_APROVADO]: 'Aprovado',
    [ContratoStatus.ANALISE_OPERACIONAL_NEGADO]: 'Ponto de atenção',
  };
  return statusMapping[status] || `Status Desconhecido (${status})`;
};

export const mapTipoContratoText = (tipoContrato) => {
  switch (tipoContrato) {
    case TipoContrato.ASSESSOR:
      return 'assessor';
    case TipoContrato.ENTE_PUBLICO:
      return 'ente-publico';
    case TipoContrato.ENTE_PRIVADO:
      return 'ente-privado';
    default:
      return `TipoContrato desconhecido (${tipoContrato})`;
  }
};

export const mapTipoFluxoToText = (tipoFluxo) => {
  switch (tipoFluxo) {
    case TipoFluxo.CENTRALIZADO:
      return '';
    case TipoFluxo.DESCENTRALIZADO:
      return '-descentralizado';
    default:
      return `tipoFluxo desconhecido (${tipoFluxo})`;
  }
};
